import { useCallback } from 'react';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import ConnectButton from '../components/connect-button';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useNavigate, useLocation, useParams, Link } from 'react-router-dom';
import A from '@mui/material/Link';
import NFTVideo from '../components/nft2025';
import { T, P } from '../components/Typography';
import theme from '../theme';
import { observer } from 'mobx-react-lite';
import { NFT2025ID } from '../constants.js';

const D = () => <Divider sx={{ m: 4, mb: 4 }} />;

function NFT({ NFT} ) {
  const navigate = useNavigate();
  const location = useLocation();

  const goBuy = useCallback(() => {
    navigate('/nft/2025/buy');
  }, [navigate]);

  const viewInNFTExplorer = useCallback(() => {
    const url = `https://explorer.perawallet.app/asset/${NFT2025ID}`;
    if (!window.open(url))
      location.href = url;
  }, [NFT2025ID]);

  return <Box>
    <Typography align="center" variant="h1" color="primary" sx={{ mb: 3 }}>2025 Algorand Birthday NFT</Typography>
    <Box sx={{overflow: 'hidden', maxWidth: '95vw' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3, mb: 3, overflow: 'hidden' }}> 
        <NFTVideo />
      </Box>
    </Box>
    <T>This NFT celebrates Algorand MainNet's <P>6 years </P>of fast & stable operation since Block Zero. In the animation, the Algorand logo rotates and reconfigures itself to show the roman numeral <P>VI</P> for 6.</T>
    <T>It is a fractional NFT with up to <P>520 copies</P> available for purchase during June 12, 2025. 40 of these are reserved and the other 480 are available to be claimed. Any NFTs not claimed or sold on June 12th, 2025 (UTC) will be burned.</T>
    <T>It is minted with the special occasion <P>JUNEII..CAME</P> address to mark the occasion. All future NFTs will be minted with the same address.</T>
    <T><P>This year the birthday NFT can not be purchased.</P> Instead, it can be claimed for free by:</T>
    <T>1) Anyone who attends the June 12th midnight countdown<br/>2) Anyone who has ever claimed or bought an NFT from this site in the past.</T>
    <T>You can check eligible accounts in <A href="https://docs.google.com/spreadsheets/d/1ZvjTOKMPqr1AfruIFGnDIJuXgWw8CuHKTSeZSd1eEUE" target="_blank">this spreadsheet</A>.</T>
    <D />
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'column', md: 'row' }, justifyContent: 'center' }}>
        <Button onClick={goBuy} variant="contained">Check Availability</Button>
        <Box sx={{ width: 10, height: 10}} >&nbsp;</Box>
        <Button onClick={viewInNFTExplorer} variant="outlined">View on Pera Explorer</Button>
      </Box>
    </Box>
    <D />
    <T>The NFT is recognized as a collectible on the Pera NFT Wallet and the video displays properly on both Android and iOS. The encoding used is common enough to be supported by Pera, as well as future NFT wallets, for years to come. The video file is stored immutably on IPFS.</T>
    <T>If you were present on this website during June 12, 2025, 00:00 UTC, your browser received a code that makes you eligible for a free copy of the NFT. This will be applied automatically.</T>
  </Box>;
}

export default observer(NFT);
